const Order = require('@/lib/Orders/Order');
const { toBool, toString } = require('@/functions/transform');

/**
 * Represents the response from the order creation endpoint.
 */
class OrderResponse {
    constructor() {
        this.lineRedemption = null;
        this.message = '';

        /**
         * Note: This will not be a complete order. It will only contain:
         * - bookingRef
         * - orderID
         * - items
         * - documentNumbers
         *
         * @type {Order}
         */
        this.order = null;

        this.pushedToSocket = false;
        this.success = false;
    }

    getHydrationMap() {
        return {
            lineRedemption: {},
            message: toString,
            order: {
                model: Order,
            },
            pushedToSocket: toBool,
            success: toBool,
        };
    }
}

module.exports = OrderResponse;
